import { Box, Checkbox, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { DatePickerProps, DateRangePicker } from '@verantos-dev/shared-components';

type IndexDateRangeSectionProps = {
  isEditable: boolean;
  indexStartDatePicker: DatePickerProps;
  indexEndDatePicker: DatePickerProps;
  isDateRangeEnabled: boolean;
  onClickDateRangeCheckbox: () => void;
};

const IndexDateRangeSection = ({
  isEditable,
  indexStartDatePicker,
  indexEndDatePicker,
  isDateRangeEnabled,
  onClickDateRangeCheckbox,
}: IndexDateRangeSectionProps) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Box
      sx={{
        marginTop: theme.spacing(6),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginY: theme.spacing(4),
        }}
      >
        <Checkbox
          sx={{
            marginLeft: `-${theme.spacing(3)}`,
          }}
          aria-checked={isDateRangeEnabled}
          checked={isDateRangeEnabled}
          onClick={onClickDateRangeCheckbox}
          readOnly={!isEditable}
        />
        <Typography
          sx={{
            cursor: !isEditable ? 'not-allowed' : 'pointer',
            color: theme.palette.text.primary,
          }}
          variant="body1"
          onClick={onClickDateRangeCheckbox}
        >
          {intl.formatMessage({
            id: 'projects.cohortBuilderPage.setIndexDateDialog.restrictIndexDateCheckbox',
          })}
        </Typography>
      </Box>
      <Box>
        <DateRangePicker
          id="index-date-range-date-picker"
          startDatePicker={indexStartDatePicker}
          endDatePicker={indexEndDatePicker}
          width={240}
        />
      </Box>
    </Box>
  );
};

export default IndexDateRangeSection;
